import { BaseError } from './AuthError';

export class DomainError extends BaseError {
  constructor(message: string, code: string = 'DOMAIN_ERROR', statusCode: number = 400) {
    super(message, code, statusCode);
  }
}

export class ValidationError extends DomainError {
  constructor(message: string, public readonly field?: string) {
    super(message, 'VALIDATION_ERROR', 400);
  }
}

export class NotFoundError extends DomainError {
  constructor(resource: string = 'Recurso') {
    super(`${resource} não encontrado`, 'NOT_FOUND', 404);
  }
}

export class BusinessRuleError extends DomainError {
  constructor(message: string) {
    super(message, 'BUSINESS_RULE_VIOLATION', 422);
  }
}